'use strict';

export function initAnchorClickScroll(
  offset = 0,
  container = null,
  noPushClass = 'no-hash'
) {
  function scrollToTarget(target) {
    if (!target) return;

    if (
      window.smoothScroll &&
      typeof window.smoothScroll.scrollIntoView === 'function'
    ) {
      window.smoothScroll.scrollIntoView(target, {
        alignToTop: true,
        onlyScrollIfNeeded: false,
        container: container || undefined,
      });
    } else {
      const y =
        target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const hash = link.getAttribute('href');
    if (!hash || hash === '#') return;

    const id = decodeURIComponent(hash.substring(1));
    const target = document.getElementById(id);
    if (!target) return;

    e.preventDefault();
    scrollToTarget(target);

    // jeśli link nie ma klasy wyłączającej hash w pasku
    if (!link.classList.contains(noPushClass)) {
      history.pushState(null, null, hash);
    }
  });
}

export function scrollToHashOnLoad(offset = 0, container = null) {
  const hash = window.location.hash;
  if (!hash || hash === '#') return;

  const id = decodeURIComponent(hash.substring(1));
  const target = document.getElementById(id);
  if (!target) return;

  // mały timeout na załadowanie contentu
  setTimeout(() => {
    if (
      window.smoothScroll &&
      typeof window.smoothScroll.scrollIntoView === 'function'
    ) {
      window.smoothScroll.scrollIntoView(target, {
        alignToTop: true,
        onlyScrollIfNeeded: false,
        container: container || undefined,
      });
    } else {
      const y =
        target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }, 300);
}

export function initTocSpy(activeClass = 'is-active', offset = 100, container = null) {
  const links = document.querySelectorAll('a[href^="#"]');
  const sections = [];

  const scrollContainer = container || document.scrollingElement || document.documentElement;

  links.forEach(link => {
    const hash = link.getAttribute('href');
    if (!hash || hash === '#') return;

    const id = decodeURIComponent(hash.substring(1));
    const el = document.getElementById(id);

    if (el) {
      // top względem scrollContainer
      const rect = el.getBoundingClientRect();
      const containerRect = scrollContainer.getBoundingClientRect();
      const top = rect.top - containerRect.top + (window.smoothScroll ? window.smoothScroll.offset.y : 0);

      sections.push({ id, el, link, top });
    }
  });

  if (!sections.length) return;

  const setActive = (currentId) => {
    links.forEach(l => l.classList.remove(activeClass));
    const active = sections.find(s => s.id === currentId);
    if (active) active.link.classList.add(activeClass);
  };

  const update = (scrollY) => {
    let current = sections[0].id;

    for (let i = 0; i < sections.length; i++) {
      if (scrollY + offset >= sections[i].top) {
        current = sections[i].id;
      } else {
        break;
      }
    }

    setActive(current);
  };

  if (window.smoothScroll && typeof window.smoothScroll.addListener === 'function') {
    window.smoothScroll.addListener(({ offset }) => {
      update(offset.y);
    });

    // initial call
    update(window.smoothScroll.offset?.y || 0);
  } else {
    window.addEventListener('scroll', () => {
      const scroll = window.scrollY || document.documentElement.scrollTop;
      update(scroll);
    });

    update(window.scrollY || 0);
  }
}

export function initTocSpy_BED(activeClass = 'is-active', offset = 100, container = null) {
  const links = document.querySelectorAll('a[href^="#"]');
  const sections = [];

  const scrollContainer = container || document.scrollingElement || document.documentElement;

  links.forEach(link => {
    const hash = link.getAttribute('href');
    if (!hash || hash === '#') return;

    const id = decodeURIComponent(hash.substring(1));
    const el = document.getElementById(id);

    if (el) {
      // obliczamy pozycję sekcji względem scrollContainer
      const rect = el.getBoundingClientRect();
      const containerRect = scrollContainer.getBoundingClientRect();
      const top = rect.top - containerRect.top + (window.smoothScroll ? window.smoothScroll.offset.y : 0);
      const height = el.offsetHeight;

      sections.push({ id, el, link, top, height });
    }
  });

  if (!sections.length) return;

  const setActive = (currentId) => {
    links.forEach(l => l.classList.remove(activeClass));
    const active = sections.find(s => s.id === currentId);
    if (active) active.link.classList.add(activeClass);
  };

  const update = (scrollY) => {
    let current = sections[0].id;

    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];

      const sectionTop = section.top;
      const sectionBottom = section.top + section.height;

      // jeśli sekcja częściowo widoczna od góry lub od dołu → aktywna
      if ((scrollY + offset >= sectionTop && scrollY + offset <= sectionBottom) ||
        (scrollY >= sectionTop && scrollY <= sectionBottom)) {
        current = section.id;
        break; // zawsze bierzemy pierwszą widoczną sekcję
      }

      // jeśli scroll jest już poniżej sekcji, traktujemy ją jako aktywną
      if (scrollY + offset >= sectionBottom) {
        current = section.id;
      }
    }

    setActive(current);
  };

  if (window.smoothScroll && typeof window.smoothScroll.addListener === 'function') {
    window.smoothScroll.addListener(({ offset }) => {
      update(offset.y);
    });
    update(window.smoothScroll.offset?.y || 0);
  } else {
    window.addEventListener('scroll', () => {
      const scroll = window.scrollY || document.documentElement.scrollTop;
      update(scroll);
    });
    update(window.scrollY || 0);
  }
}